import Button from '@rezdy/components/Button';
import Layout from './Layout';
import Message from './Message';
import React from 'react';
import routes from '../constants/routes';
import routing from '../services/routing';
import { WithTranslation, withTranslation } from 'react-i18next';

class CompleteForgotPassword extends React.PureComponent<WithTranslation> {
    onClick = () => {
        routing.push(routes.SIGN_IN);
    };

    render() {
        const { i18n } = this.props;
        return (
            <Layout>
                <Message>{i18n.t('RESET_PASSWORD_COMPLETE')}</Message>
                <Button action="primary" width="100%" onClick={this.onClick}>
                    {i18n.t('primaryAction', { context: 'signIn' })}
                </Button>
            </Layout>
        );
    }
}

export default withTranslation()(CompleteForgotPassword);
